import { fetchQuery } from '@/services/messaging/fetchQuery';
import { assignFeatureFlag } from '@/directives/FeatureFlags.js';
import router from '@/router';
import axios from "axios";

export function getCurrentUserIdentity() {
  var response = fetchQuery('GetCurrentUserIdentity', {}).then((response) => {
    if (response && response.isSecurityPolicyExpired !== false) {
      router.push('/closeddepartment');
    }
    if (response && response.ssoId) {
      window.localStorage.setItem('lastSelectedCustomer', response.ssoId);
      setAxiosCustomerId(response.ssoId);
    }
    assignFeatureFlag(response);
    return response;
  });
  return response;
}


function setAxiosCustomerId(customerId) {
  axios.defaults.headers.common["customerid"] = customerId;
}
